import { API_ORIGIN, api, session } from './api';

export const MIGRATION_UNAVAILABLE = 'Sync is not available on the server yet. Your guest session has been kept; you can continue using Tap Talk Save.';

// Do not guess migration fields or send guest credentials to Google. Enable
// linking only when the EXISTING API advertises a guest credential in its
// session-exchange request schema. Otherwise leave the guest identity intact.
export async function getMigrationContract() {
  let response;
  try {
    response = await fetch(`${API_ORIGIN}/openapi.json`, {
      cache: 'no-store', headers: session.get() ? { Authorization: `Bearer ${session.get()}` } : {},
    });
  } catch { throw new Error('Could not check account sync. Your guest saves are unchanged. Please try again.'); }
  if (!response.ok) throw new Error(MIGRATION_UNAVAILABLE);
  const doc = await response.json();
  let schema = doc.paths?.['/api/auth/session']?.post?.requestBody?.content?.['application/json']?.schema;
  if (schema?.$ref?.startsWith('#/components/schemas/')) schema = doc.components?.schemas?.[schema.$ref.split('/').pop()];
  const properties = schema?.properties;
  // Only transmit a field actually declared by this server, never an assumed
  // guest_token property accepted/ignored by the old sign-in-only API.
  const field = ['guest_session_token', 'guest_token'].find(name => properties?.[name]);
  if (!field) throw new Error(MIGRATION_UNAVAILABLE);
  return { field };
}

export async function prepareOptionalSignIn() {
  const token = session.kind() === 'guest' ? session.get() : session.retainedGuest();
  if (token) {
    session.retainGuest(token);
    await getMigrationContract();
  }
  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  const url = new URL(process.env.REACT_APP_AUTH_URL);
  url.searchParams.set('redirect', `${window.location.origin}/auth/callback`);
  window.location.assign(url.toString());
}

export async function exchangeOptionalAccount(sessionId) {
  const guestToken = session.kind() === 'guest' ? session.get() : session.retainedGuest();
  let migration = null;
  if (guestToken) {
    session.retainGuest(guestToken);
    const contract = await getMigrationContract();
    migration = { field: contract.field, token: guestToken };
  }
  const data = await api.exchange(sessionId, migration);
  if (typeof data?.session_token !== 'string' || !data?.user || data.user.is_guest === true) {
    throw new Error('Account sync did not complete. Your existing session has been kept.');
  }
  // The server owns migration. Never recreate notes in the browser or attach
  // guest IDs to an account without proving possession of the guest token.
  session.set(data.session_token, 'account');
  return data.user;
}